import Rete from "rete";
import './CustomNodeToJsonParser.js';  // required for prototype register toCustomJSON()
import {SequenceComponentHelper} from "./SequenceComponentHelper";
import {SequenceComponent} from "../components";

export class CustomNodeEditor extends Rete.NodeEditor {

    toJSON() {
        const data = { id: this.id, nodes: {} };

        this.nodes.forEach(node => {
            //data.nodes[node.id] = node.toJSON();
            data.nodes[node.id] = this.nodeToJSON(node);
        });
        this.trigger('export', data);
        return data;
    }

    nodeToJSON(node) {
        const reduceIO = (list) => {
            return Array.from(list).reduce((obj, [key, io]) => {
                obj[key] = io.toJSON();
                return obj;
            }, {})
        }

        SequenceComponentHelper.normalizeTextAnswersOrder(node.data);
        SequenceComponentHelper.normalizeInfosOrder(node.data);

        return {
            'id': node.id,
            'componentId': node.componentId, // added field. standard node.toJSON() does not has this
            'labelColor': node.labelColor, // added field. standard node.toJSON() does not has this
            'customName': node.customName, // added field. standard node.toJSON() does not has this
            'data': node.data,
            'inputs': reduceIO(node.inputs),
            'outputs': reduceIO(node.outputs),
            'position': node.position,
            'name': node.name,
            'isCollapsed': node.isCollapsed
        }
    }

    async fromJSON(json) {
        // TODO: #1 - this is temp fix
        // remove in future
        // for now this is required to support old VideoWithOutput component
        const oldJsonStr = JSON.stringify(json);
        const newJsonStr = oldJsonStr.replaceAll(SequenceComponent.VIDEO_WITH_OUTPUT_CHILD_COMPONENT_KEY, SequenceComponent.VIDEO_CHILD_COMPONENT_KEY);
        json = JSON.parse(newJsonStr);
        // end #1

        if (!this.beforeImport(json)) return false;
        const nodes = {};

        try {        
            await Promise.all(Object.keys(json.nodes).map(async id => {
                const node = json.nodes[id];
              
                if (node.data) {
                    Object.keys(node.data).forEach(dataKey => {
                        const keyType = (dataKey.split('_'))[2];
                        if (keyType === "startRotation") {
                            delete node.data[dataKey];
                        }
                    });
                }

                const component = this.getComponent(node.name);
                nodes[id] = await component.build(this.nodeFromJSON(node));

                this.addNode(nodes[id]);
            }));

            Object.keys(json.nodes).forEach(id => {
                const jsonNode = json.nodes[id];
                const node = nodes[id];

                Object.keys(jsonNode.outputs).forEach(key => {
                    const outputJson = jsonNode.outputs[key];

                    outputJson.connections.forEach(jsonConnection => {
                        const nodeId = jsonConnection.node;
                        const data = jsonConnection.data;
                        const targetOutput = node.outputs.get(key);
                        const targetInput = nodes[nodeId].inputs.get(jsonConnection.input);

                        if (!targetOutput || !targetInput) {
                            return this.trigger('error', `IO not found for node ${node.id}`);
                        }

                        this.connect(targetOutput, targetInput, data);
                    });
                });

            });
        } catch (e) {
            this.trigger('warn', e);
            return !this.afterImport();
        }

        this.trigger('dataImported');
        return this.afterImport();
    }

    nodeFromJSON(json) {
        const node = new Rete.Node(json.name);
        const [x, y] = json.position;

        node.id = json.id;
        node.componentId = json.componentId;
        node.labelColor = json.labelColor;
        node.customName = json.customName;
        node.data = json.data;
        node.position = [x, y];
        node.name = json.name;
        node.isCollapsed = json.isCollapsed;
        Rete.Node.latestId = Math.max(node.id, Rete.Node.latestId);

        return node;
    }

    toCustomJSON() {
        const updateLessonNodesRequest = {
            //id: this.id,
            jsonConfig: this.toJSON(),
            nodes: [],
            connections: []
        };

        this.nodes.forEach(node => {
            SequenceComponentHelper.normalizeTextAnswersOrder(node.data);
            SequenceComponentHelper.normalizeInfosOrder(node.data);

            updateLessonNodesRequest.nodes.push(node.customToJSON(node));

            // handle connections
            let outputsArr = Array.from(node.outputs);
            outputsArr.forEach(output => {
                let nodeOutputId = output[0].split('_')[0];
                output[1].connections.map(c => {
                    if (!c.input.node) throw new Error('Node not added to Input');
                    const nodeInputId = c.input.node.componentId;
                    updateLessonNodesRequest.connections.push({
                        nodeInputId: nodeInputId,
                        nodeOutputId: nodeOutputId
                    });
                });
            });

            const nodeDataIds = SequenceComponentHelper.getDataIds(node.data);
            if (nodeDataIds.defaultVoiceAnswerId != null) { // if node has default voice answer
                const defaultNodeId = node.data[SequenceComponentHelper.getDefaultVoiceAnswerNodeSearchKey(nodeDataIds.defaultVoiceAnswerId)];
                if (defaultNodeId) { // if default node is selected, then add this connection
                    const defaultNode = this.nodes.find(node => node.id === defaultNodeId);
                    const defaultNodeComponentId = defaultNode.componentId;
                    updateLessonNodesRequest.connections.push({
                        nodeInputId: defaultNodeComponentId,
                        nodeOutputId: nodeDataIds.defaultVoiceAnswerId
                    });
                }
            }
        });

        this.trigger('export', updateLessonNodesRequest);

        return updateLessonNodesRequest;
    }
}